
import { defineComponent } from "vue";

export default defineComponent({
  name: "GameInfoPoint",

  data() {
    return {
      isOpen: false,
    };
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    colorClass() {
      return this.value ? "green" : "red";
    },
  },
});
